import { hasPermission } from "@/router/protected-routes"
import { useAbilities } from "@/stores/abilities"
import type { RouteRecordRaw } from "vue-router"

function getAbilityName() {
  const abilitiesStore = useAbilities()
  return abilitiesStore.ability.name || ""
}

const abilityRoutes: RouteRecordRaw[] = [
  {
    path: "",
    name: "abilitiesList",
    component: () => import("@/templates/abilities/AbilitiesList.vue")
  },
  {
    path: "details/:abilityId",
    name: "abilityDetails",
    component: () => import("@/templates/abilities/AbilityDetail.vue"),
    meta: { breadcrumb: getAbilityName }
  },
  {
    path: "create",
    name: "abilityCreate",
    component: () => import("@/templates/abilities/AbilityCreateAndUpdate.vue"),
    meta: { breadcrumb: "abilities.create.breadcrumb" },
    beforeEnter: () => {
      return hasPermission("/api/v1/abilities", "post")
    }
  },
  {
    path: "edit/:abilityId",
    name: "abilityEdit",
    component: () => import("@/templates/abilities/AbilityCreateAndUpdate.vue"),
    meta: { breadcrumb: getAbilityName },
    beforeEnter: () => {
      return hasPermission("/api/v1/abilities/update", "put")
    }
  }
]

export default abilityRoutes
